import { Component, OnInit, Renderer2, Inject, ViewChild } from '@angular/core';
import { Session } from 'src/app/models/session';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';
import { MapChartComponent } from '../map-chart/map-chart.component';

declare function drawRegionsMap(): any;
declare function setMapData(data): any;

@Component({
  selector: 'app-tecnicos',
  templateUrl: './tecnicos.component.html',
  styleUrls: ['./tecnicos.component.css']
})
export class TecnicosComponent implements OnInit {

  @ViewChild('map',null) map:MapChartComponent;

  constructor(public session: Session, private service: UserService, private toast: ToastrService,private _renderer2: Renderer2, @Inject(DOCUMENT) private _document: Document) {
   }

  ngOnInit() {

    
    this.service.getTecnicos().subscribe(d=>{
      this.tecnicos = d;
      this.tecnicos.forEach(t=> {
        t.data = (t.nombre + " " + t.apellido + " " + t.legajo).toLowerCase();

        let provincias = new Set();
        t.zonas.forEach(z=> provincias.add(z.provincia));
        t.provincias = provincias;


        t.zonas.forEach(z=>{this.provincias.add(z.provincia)});

        setTimeout(() => {
          this.map.updateMap();
        }, 1000);
      });
      this.selectProvincia();
      
      
    }, er=>{
      this.toast.error(er.error);
    })
  }

  tecnicos = [];
  provincias = new Set();
  selectedProvincia = "";
  selectedLocalidad = "";
  localidades = new Set();
  searchText="";

  selectProvincia(){
    this.localidades.clear();
    this.tecnicos.forEach( t=>{
      t.zonas.forEach( z=>{
        if(z.provincia == this.selectedProvincia) this.localidades.add(z.localidad);
      });
    });
    this.selectedLocalidad ="";
  }

  filter(){
    let ret = [];
    ret = this.tecnicos.filter( x => this.searchText.length==0 ||  x.data.indexOf(this.searchText.toLowerCase())>=0);
    if(this.selectedProvincia!="") ret = ret.filter( x => Array.from(x.provincias).indexOf(this.selectedProvincia)>=0 );

    if(this.selectedLocalidad!="") ret = ret.filter( x => x.zonas.filter( z=> z.provincia == this.selectedProvincia).map(z=>{ return z.localidad } ).indexOf(this.selectedLocalidad)>=0 );
    
    return ret;
  }

  getMapData(){
    return this.tecnicos;
  }
  
  sortState ={};
  sort(column){
    this.sortState[column] = !this.sortState[column];
    this.filter();
    this.tecnicos = this.tecnicos.sort( (a,b) =>{
      return  (a[column] > b[column] )? (this.sortState[column]?1:-1) :(this.sortState[column]?-1:1);
    })
    this.filter();
    
  }

  getCsv(){
    this.service.getTecnicosCsv().subscribe(d=>{
      this.createCsv(d);
    }, er=>{
      this.createCsv(er.error.text);
    })
  }

  createCsv(content){
    var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
      element.setAttribute('download', "Tecnicos.csv");
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
  }

}
